export default __webpack_public_path__ + "static/media/save-content-black.4bc355f5.svg";